import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";
import { useTheme } from "../context/ThemeContext";
import "./Navigation.css";

const ThemeIcon = ({ theme }) => {
  if (theme === "light") return <span title="Light mode">☀️</span>;
  return <span title="Dark mode">🌙</span>;
};

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAdmin, logout } = useAdmin();
  const { theme, cycleTheme } = useTheme();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" onClick={closeMenu}>
            <strong>Russell Romney</strong>
          </Link>
        </div>

        <button
          className={`hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/articles" onClick={closeMenu}>
              Articles
            </Link>
          </li>
          <li>
            <Link to="/blog" onClick={closeMenu}>
              Blog
            </Link>
          </li>
          <li>
            <Link to="/feed" onClick={closeMenu}>
              News Feed
            </Link>
          </li>
          <li>
            <Link to="/queue" onClick={closeMenu}>
              Queue
            </Link>
          </li>
          <li>
            <Link to="/suggestions" onClick={closeMenu}>
              Suggest
            </Link>
          </li>
          <li>
            <Link to="/projects" onClick={closeMenu}>
              Projects
            </Link>
          </li>
          <li className="theme-toggle-item">
            <button onClick={cycleTheme} className="theme-toggle-btn" aria-label="Toggle theme">
              <ThemeIcon theme={theme} />
            </button>
          </li>
          <li className="admin-nav-item">
            {isAdmin ? (
              <>
                <Link to="/admin" onClick={closeMenu} className="admin-btn">
                  Admin
                </Link>
                <button onClick={handleLogout} className="admin-btn admin-btn-logout">
                  Logout
                </button>
              </>
            ) : (
              <Link to="/admin" onClick={closeMenu} className="admin-btn">
                Admin
              </Link>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
